import {createContext} from "react";

export const SocketContext=createContext()
export const WhiteBoardContext=createContext()